import React from 'react';
import { Disclosure } from '@headlessui/react';
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline'
interface FaqProps {
  question: string;
  answer: string;
}

interface FaqComponentProps {
  questions: FaqProps[];
}

export default function Faq({ questions }: FaqComponentProps) {
  return (
    <div>
      <h2 className="text-3xl font-extrabold text-gray-900 mb-8">
        Frequently Asked Questions
      </h2>

      <dl className="space-y-6 divide-y divide-gray-900/10">
        {questions.map((faq, index) => (
          <Disclosure as="div" key={index} className="pt-6 first:pt-0">
            {({ open }) => (
              <>
                <dt>
                  <Disclosure.Button className="group flex w-full items-start justify-between text-left">
                    <span className="text-lg font-medium text-gray-900">
                      {faq.question}
                    </span>
                    <span className="ml-6 flex h-7 items-center">
                      {open ? (
                        <MinusIcon
                          className="h-6 w-6 text-gray-400 group-hover:text-gray-500"
                          aria-hidden="true"
                        />
                      ) : (
                        <PlusIcon
                          className="h-6 w-6 text-gray-400 group-hover:text-gray-500"
                          aria-hidden="true"
                        />
                      )}
                    </span>
                  </Disclosure.Button>
                </dt>
                <Disclosure.Panel as="dd" className="mt-2 pr-12">
                  <p className="text-base text-gray-500">
                    {faq.answer}
                  </p>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        ))}
      </dl>
    </div>
  );
}